import { render, staticRenderFns } from "./AnamnesiBotoxViewComponent.vue?vue&type=template&id=2060513b"
import script from "./AnamnesiBotoxViewComponent.vue?vue&type=script&lang=js"
export * from "./AnamnesiBotoxViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports